import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m8.14 15.997 1.86-4.04 1.86 4.04c.54 1.172.81 1.757.524 2.18l-.024.035c-.305.41-.99.41-2.36.41s-2.055 0-2.36-.41l-.024-.035c-.286-.423-.016-1.008.523-2.18"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "10",
      cy: "10.29",
      r: "1.667",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M3.333 15.29a8.333 8.333 0 1 1 13.333 0"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M6.273 13.622a5 5 0 1 1 7.454 0"
    }, null, -1)
  ]))]))
}
export default { render: render }